import { Tabs, TabsList, TabsTrigger } from '@/components/ui';
import { Link, useLocation } from 'react-router-dom';
import { useDocumentTitle } from '@/hooks';
import routes from '@/lib/routes';
import { SecuredComponent } from '@/components/hoc';
import { AdminUserPermissionsEnum } from '@/lib/enum';

const TabMenus = () => {
	const { pathname } = useLocation();
	const tabSelected = pathname.split('/').reverse()[0];

	useDocumentTitle({
		title:
			tabSelected === 'promotions'
				? 'Promotions marketing'
				: tabSelected === 'promo-codes'
					? 'Codes promo'
					: 'Marketing',
	});

	return (
		<Tabs className='pt-3 md:pt-5' value={tabSelected}>
			<TabsList className='w-full flex md:w-auto md:inline-flex'>
				<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.MARKETING]}>
					<TabsTrigger asChild className='flex-1 md:flex-none px-2 md:px-3 text-[12px] md:text-sm' value='messages'>
						<Link replace to={routes.nav.marketing.messages.getHref()}>
							Marketing
						</Link>
					</TabsTrigger>
				</SecuredComponent>
				<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PROMOTION]}>
					<TabsTrigger asChild className='flex-1 md:flex-none px-2 md:px-3 text-[12px] md:text-sm' value='promotions'>
						<Link replace to={routes.nav.marketing.promotions.getHref()}>
							Promotions
						</Link>
					</TabsTrigger>
				</SecuredComponent>
				<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PROMOTION]}>
					<TabsTrigger asChild className='flex-1 md:flex-none px-2 md:px-3 text-[12px] md:text-sm' value='promo-codes'>
						<Link replace to={routes.nav.marketing.promoCodes.getHref()}>
							Codes promo
						</Link>
					</TabsTrigger>
				</SecuredComponent>
				<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.BULK_NOTIFICATIONS]}>
					<TabsTrigger asChild className='flex-1 md:flex-none px-2 md:px-3 text-[12px] md:text-sm' value='bulk-notifications'>
						<Link replace to={routes.nav.marketing.bulkNotifications.getHref()}>
							Notifications push
						</Link>
					</TabsTrigger>
				</SecuredComponent>
			</TabsList>
		</Tabs>
	);
};

export default TabMenus;
